import {
  SUPPORTED_LANGS,
  lookupTag,
  normalizeLang,
  toDeepL,
} from "./tagTranslation";

/**
 * Bygger { en_US: [...], nb_NO: [...], es_ES: [...], sv_SE: [...], nl_NL: [...] }
 *
 * @param tagList    tags på kildespråket
 * @param fromLang   kildespråk (textInformation.lang)
 * @param translate  ({ texts, toWhatLang, fromWhatLang }) => Promise<string[]>
 * @param existing   allerede-oversatte lister som skal vinne, f.eks.
 *                   { en_US: textInformation.tags_enUS }
 * @param langs      hvilke språk som skal fylles (default: alle)
 */
export const buildTagsLang = async ({
  tagList,
  fromLang,
  translate,
  existing = {},
  langs = SUPPORTED_LANGS,
}) => {
  const source = Array.isArray(tagList) ? tagList.filter(Boolean) : [];
  const fromKey = normalizeLang(fromLang) ?? "nb_NO";

  const out = {};

  // Kildespråket er alltid seg selv
  out[fromKey] = source;

  const targets = langs.filter((l) => l !== fromKey);

  await Promise.all(
    targets.map(async (toKey) => {
      // 1) Manuelt redigert / allerede oversatt i UI-et vinner
      const prior = existing[toKey];
      if (Array.isArray(prior) && prior.length === source.length) {
        out[toKey] = prior;
        return;
      }

      // 2) Lokalt oppslag i tags.json
      const result = new Array(source.length);
      const missIdx = [];
      const missTexts = [];

      source.forEach((tag, i) => {
        const hit = lookupTag(tag, fromKey, toKey);
        if (hit !== null) result[i] = hit;
        else {
          missIdx.push(i);
          missTexts.push(tag);
        }
      });

      // 3) Kun det som mangler går til DeepL
      if (missTexts.length) {
        const translated = await translate({
          texts: missTexts,
          toWhatLang: toDeepL(toKey),
          fromWhatLang: toDeepL(fromKey),
        });
        missIdx.forEach((idx, j) => {
          result[idx] = translated?.[j] ?? missTexts[j];
        });
      }

      out[toKey] = result;
    }),
  );

  return out;
};